<div class="card arquivo-card-view">
    <div class="card-header">
        <h6 class="card-title">
            {{title}}
        </h6>
        <p class="form-text text-muted" [innerHTML]="headerText" *ngIf="headerText"></p>
    </div>

    <sgt-arquivo-upload-table
        [canEdit]="canEdit"
        [idTable]="idTable"
        [arquivosUpload]="arquivosUpload"
        (delete)="onDelete($event)">
    </sgt-arquivo-upload-table>

    <div class="card-footer" *ngIf="canEdit">
        <button type="button" class="btn btn-primary" (click)="openUploadModal()">
            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Arquivos
        </button>                 
    </div>
</div>

<sgt-arquivo-upload-modal
    #uploadModal
    [autoUpload]="false"
    (afterAdd)="onAdd($event)">
</sgt-arquivo-upload-modal>